import { ExtraCost } from './extraCost';
import { Remark } from './remark';
import { OrderActuals } from './order.actuals';
import { Moment } from 'moment';
import { SelectedTimeslot } from './selectedTimeslot';
import { TransportInformation } from '../transport-information/transport-information';
import { CmrStatus } from '../enum/cmrStatus';
import { CommonUtils } from '../../utils/common.utils';
import { OrderDocument } from './orderDocument';
import { DocumentStatus } from '../enum/documentStatus';
import { RejectedByDetails } from './rejectedByDetails';
import { TransportInfoStatus } from '../enum/transportInfoStatus';
import { TransportInformationTemplate } from '../transport-information/transport-information-template';

export enum ActualsType {
  LoadingArrival = 0,
  StartLoading = 1,
  EndLoading = 2,
  LoadingDeparture = 3,
  DeliveryArrival = 4,
  DeliveryDeparture = 5,
}

export class Order {
  id: string;
  status: string;
  remark: string;
  orderId: string;
  loadingPl: string;
  delivPl: string;
  loadingDate: string;
  delivDate: string;
  product: string;
  productDetail: string;
  salesNr: number;
  carrierRef: number;
  loadingTs: string;
  deliveryTs: string;
  actuals: OrderActuals;
  costLine: ExtraCost[];
  loadingAddressId: number;
  deliveryAddressId: number;
  remarks: Remark;
  loadingDates: Moment[];
  deliveryDates: Moment[];
  loadingTimeslot: SelectedTimeslot;
  deliveryTimeslot: SelectedTimeslot;
  loadingTimeslotRequired: boolean;
  deliveryTimeslotRequired: boolean;
  transportInformation: TransportInformation;
  maxLoadingDateTime: Moment;
  maxDeliveryDateTime: Moment;
  dossierId: number;
  loadingReference: string;
  deliveryReference: string;
  cmrStatus: CmrStatus;
  orderDocuments: OrderDocument[];
  fmsCarrierId?: number;
  customerId: number;
  documentStatus: DocumentStatus;
  currencyId: number;
  statusName: string;
  rejectedByDetails: RejectedByDetails;
  customerName: string;
  missingRequiredDocuments: boolean;
  transportInfoStatus: TransportInfoStatus;
  previousProductTemplate: TransportInformationTemplate;
  isReadOnly: boolean;

  static fromObj(obj: any): Order {
    const order = Object.assign(new Order(), obj);
    if (obj.costLine) {
      order.costLine = [];
      for (const entry of obj.costLine) {
        order.costLine.push(ExtraCost.fromObj(entry));
      }
    }
    return order;
  }

  static orderCanBeDeliveredAtAnyTime(
    minDelivery: Moment,
    maxDelivery: Moment,
  ): boolean {
    return (
      CommonUtils.momentIsMidnight(minDelivery) &&
      CommonUtils.momentIsMidnight(maxDelivery)
    );
  }

  static orderCanBeLoadedAtAnyTime(
    minimumLoading: Moment,
    maximumLoading: Moment,
  ): boolean {
    return (
      CommonUtils.momentIsMidnight(minimumLoading) &&
      CommonUtils.momentIsMidnight(maximumLoading)
    );
  }
}
